export const locale = {
    lang: 'fr',
    data: {
        'SAMPLE': {
            'HELLO': 'Merhaba Dünya!'
        }
    }
};
